import React from 'react';
import { Modal, FormGroup, Button } from 'react-bootstrap';
import { Label } from 'fw/components';
import { Form, TextAreaBox } from 'fw/forms';
import { DocumentUpload } from 'areas/shared/controls';

// NVBDC-1404 — pencil-icon popup, modeled on businessStructure/businessStaffPopUp.js: edits the
// parent's local one-sheet state only via onSave, no independent API call (Phase 2 "stage
// locally" save model). The mockup's "New PDF? Select File" line next to Company Capabilities is
// this upload — capabilitiesStatementStorageToken/FileName already round-trip through
// SaveOneSheet (OneSheetRenewal.js's buildSaveOneSheetRequest), this popup just never surfaced it.
class CapabilitiesPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            form: {
                capabilitiesStatement: props.capabilitiesStatement || '',
                capabilitiesStatementStorageToken: props.capabilitiesStatementStorageToken || null,
                capabilitiesStatementFileName: props.capabilitiesStatementFileName || null
            }
        };
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            form: {
                capabilitiesStatement: nextProps.capabilitiesStatement || '',
                capabilitiesStatementStorageToken: nextProps.capabilitiesStatementStorageToken || null,
                capabilitiesStatementFileName: nextProps.capabilitiesStatementFileName || null
            }
        });
    }

    onChange = (form) => {
        this.setState({ form });
    };

    handleUploadChange = (file) => {
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                capabilitiesStatementStorageToken: file.storageToken,
                capabilitiesStatementFileName: file.fileName
            }
        }));
    };

    save = () => {
        this.props.onSave(this.state.form);
        this.close();
    };

    close = () => {
        this.setState({ visible: false }, () => this.props.onClose());
    };

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}>
                <Modal.Header>
                    <h3>Company Capabilities</h3>
                </Modal.Header>
                <Modal.Body>
                    <Form onChange={this.onChange} values={this.state.form} ref={(form) => { this._form = form; }}>
                        <FormGroup>
                            <Label htmlFor="capabilitiesStatement" required>Describe your company's capabilities</Label>
                            <TextAreaBox name="capabilitiesStatement" placeholder="Company Capabilities" rows={6} maxLength={2000} />
                        </FormGroup>
                    </Form>
                    <FormGroup>
                        <Label>Supporting Documentation</Label>
                        <DocumentUpload
                            storageToken={this.state.form.capabilitiesStatementStorageToken}
                            fileName={this.state.form.capabilitiesStatementFileName}
                            onChange={this.handleUploadChange}
                        />
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnSaveCapabilities" bsStyle="success" onClick={this.save}>Save</Button>
                    <Button id="btnCloseCapabilities" onClick={this.close}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default CapabilitiesPopUp;



// WEBPACK FOOTER //
// ./src/areas/certification/oneSheet/popups/CapabilitiesPopUp.js